<div class="modal-dialog-wrapper">
  <div class="title-wrapper">
    <h3>
      {{ data.title }}
    </h3>
    <button (click)="closeDetail()">
      <mat-icon class="close-icon"> close </mat-icon>
    </button>
  </div>
  <div class="modal-text">
    {{ data.text }}
  </div>
  <div class="footer-wrapper">
    @if (data.secondaryButtonText) {
      <button data-testid="dialogSecondaryButton " mat-dialog-close (click)="onSecondaryClicked()">
        {{ data.secondaryButtonText }}
      </button>
    }
    <button data-testid="dialogPrimaryButton" class="primary-button" mat-dialog-close (click)="onPrimaryClicked()">
      {{ data.primaryButtonText }}
    </button>
  </div>
</div>
